import apiService, { defaultHeaders } from 'services/apiService';

export const READ_REQUEST = 'userrequestParkings/READ_REQUEST';
export const READ_SUCCESS = 'userrequestParkings/READ_SUCCESS';
export const READ_FAILURE = 'userrequestParkings/READ_FAILURE';

const initialState = {
  isLoading: false,
  hasError: false,
  parkings: [],
};

function filterParkings (data) {
  return data.features
    .filter(feature => feature.properties.NAME);
}

export default (state = initialState, action) => {
  switch (action.type) {
    case READ_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case READ_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasError: false,
        parkings: filterParkings(action.data),
      };
    case READ_FAILURE:
      return {
        ...state,
        isLoading: false,
        hasError: true,
      };
    default:
      return state;
  }
};

export const readUserrequestParkings = () => async dispatch => {
  dispatch({ type: READ_REQUEST });

  try {
    const { data: { geojson_url: geojsonUrl } } = await apiService.request('/layer/parkings/', {
      headers: defaultHeaders,
    });
    const { data } = await apiService.request(geojsonUrl.replace(/^\/api/, ''), {
      headers: defaultHeaders,
    });
    dispatch({ type: READ_SUCCESS, data });
  } catch (error) {
    dispatch({ type: READ_FAILURE, error });
  }
};



// WEBPACK FOOTER //
// ./src/modules/userrequestParkings.js